import { datadogLogs } from '@datadog/browser-logs';

import type { MonitoringConfig, MonitoringLogs } from '../types/NextConfig';

export interface BrowserLogsProps extends MonitoringConfig, MonitoringLogs {}

let DD_LOGS_INITIALIZED = false;

const configurationBrowserLogs = ({
  clientToken,
  forwardConsoleLogs,
  logsLoggerLevel,
  logsSampleRate,
  monitoringEnv,
  serviceName,
  version,
}: BrowserLogsProps) => {
  datadogLogs.init({
    clientToken: clientToken,
    site: 'datadoghq.com',
    sessionSampleRate: logsSampleRate,
    env: monitoringEnv,
    service: serviceName,
    version: version,
    forwardConsoleLogs: forwardConsoleLogs,
  });
  datadogLogs.logger.setLevel(logsLoggerLevel);
};

export const BrowserLogs = (props: BrowserLogsProps) => {
  if (!DD_LOGS_INITIALIZED) {
    configurationBrowserLogs(props);
    DD_LOGS_INITIALIZED = true;
  }

  return null;
};
